export const LOCAL_STORAGE_SESSION_TOKEN_KEY = 'sessionToken'
export const HTTP_HEADER_SESSION_TOKEN_KEY = 'X-Session-Token'

export const STYLE_FILL_COLOR = 'fillColor'
export const PASSWORD_PATTERN = /(?=^.{6,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Za-z]).*$/
export const OWNER_NAME_PATTERN = /^(?=.{2,20}$)([\u1780-\u17FFa-zA-Z0-9]+[_\- ])*[\u1780-\u17FFa-zA-Z0-9]+$/
export const COMPANY_NAME_PATTERN = /^(?=.{2,50}$)([\u1780-\u17FFa-zA-Z0-9]+ )*[\u1780-\u17FFa-zA-Z0-9]+$/